export const contentModulesPath = '/management_panel/content_modules'

export const editContentModulePath = ({ id }) =>
  `${contentModulesPath}/${id}/edit`
